import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../Pages/Home";
import Contact from "../Pages/Contact";
import About from "../Pages/About";
import Projects from "../Pages/Projects";
import Services from "../Pages/Services";
import Feedback from "../Pages/Feedback";
import Login from "../Pages/Login";
import NotFound from "../Pages/NotFound";
import OnlineResume from "../Pages/OnlineResume";
import Admin from "../Pages/Dashboard1/Admin";
import Signup from "../Pages/Signup";
import ProjectPage from "../Pages/ProjectPage";
import ComingSoon from "../Pages/ComingSoon";
import Meetings from "../Pages/Meetings";

export default function ReactRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectName" element={<ProjectPage />} />
        <Route path="/services/*" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-meeting" element={<Meetings />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/shell/login" element={<Login />} />
        {/* <Route path="/shell/signup" element={<Signup />} /> */}
        <Route path="admin/:id/*" element={<Admin />} />
        <Route path="/online-resume" element={<OnlineResume />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
